import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-facebook\">\r\n<path d=\"M22 12.0609C22 6.50304 17.5242 2 12 2C6.47581 2 2 6.50304 2 12.0609C2 17.0824 5.65685 21.2446 10.4375 22V14.9692H7.89718V12.0609H10.4375V9.84422C10.4375 7.32292 11.9294 5.93022 14.2145 5.93022C15.3089 5.93022 16.4532 6.12657 16.4532 6.12657V8.60122H15.1919C13.95 8.60122 13.5625 9.37688 13.5625 10.1724V12.0609H16.3359L15.8923 14.9692H13.5625V22C18.3431 21.2446 22 17.0824 22 12.0609Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol